//used for mobile device to check screen orientation
$(window).on('resize', function () {
  //create a timeout to know when resize event end, so logic isn't constently ran
  clearTimeout(ht.checkOrientation);
  ht.checkOrientation();
});
